import React from 'react';
import Login from '../components/LoginForm'

function UserLogin(){
    return (
        <Login title={'User'}/>
    )
}
export default UserLogin;